import { VibeAppEndpoints } from "./endpoints/app.endpoints";
import { VibeAppEdgeEndpoints } from "./endpoints/app-edge.endpoints";
import { VibeApprovalEndpoints } from "./endpoints/approval.endpoints";
import { VibeCatalogEndpoints } from "./endpoints/catalog.endpoints";
import { VibeClusterEndpoints } from "./endpoints/cluster.endpoints";
import { VibeDeploymentEndpoints } from "./endpoints/deployment.endpoints";
import { VibeDomainEndpoints } from "./endpoints/domain.endpoints";
import { VibeEnvironmentEndpoints } from "./endpoints/environment.endpoints";
import { VibeGitContentEndpoints } from "./endpoints/git-content.endpoints";
import { VibeGitProjectEndpoints } from "./endpoints/git-project.endpoints";
import { VibeSecretEndpoints } from "./endpoints/secret.endpoints";

/**
 * Vibe API contract — single source of truth for every `/api/vibe`
 * endpoint. Backend `safeParse`s requests against these; frontend infers
 * its API client types from them.
 *
 * Every endpoint is gated behind `FeatureFlag.VIBE` on the backend.
 * The schema does not encode the gate (that's a NestJS guard concern),
 * but consumers should expect a 403 if the org has not opted in.
 */
export const ZVibe = {
  ...VibeAppEndpoints,
  ...VibeAppEdgeEndpoints,
  ...VibeGitProjectEndpoints,
  ...VibeGitContentEndpoints,
  ...VibeClusterEndpoints,
  ...VibeDeploymentEndpoints,
  ...VibeEnvironmentEndpoints,
  ...VibeSecretEndpoints,
  ...VibeApprovalEndpoints,
  ...VibeCatalogEndpoints,
  ...VibeDomainEndpoints
} as const;
